/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Even_Alert_Gadfly_BeamInputs */

const en_even_alert_gadfly_beam = /** @type {(inputs: Even_Alert_Gadfly_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select segments`)
};

const de_even_alert_gadfly_beam = /** @type {(inputs: Even_Alert_Gadfly_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmente auswählen`)
};

/**
* | output |
* | --- |
* | "Select segments" |
*
* @param {Even_Alert_Gadfly_BeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const even_alert_gadfly_beam = /** @type {((inputs?: Even_Alert_Gadfly_BeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Even_Alert_Gadfly_BeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_even_alert_gadfly_beam(inputs)
	return de_even_alert_gadfly_beam(inputs)
});